import type { FC } from 'react';
import { RiCheckboxMultipleFill } from 'react-icons/ri';
import styles from './ActivityPanel.module.scss';

/**
 * Right panel of the agent session page: the session's activity feed (thinking / tool-call events).
 * Fixed sub-header with a scrollable list below. Fixed width and independently scrollable; plain DOM,
 * outside the canvas. Empty for now — the live feed arrives with SSE.
 */
const ActivityPanel: FC = () => (
  <aside className={styles.panel} data-test-component="ActivityPanel">
    <div className={styles.header}>
      <RiCheckboxMultipleFill className={styles.headerIcon} />
      Activity
    </div>
    <div className={styles.feed} />
  </aside>
);

export default ActivityPanel;
